import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ConfigurationService } from '@draeger-academy/common';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'da-global-notification',
    templateUrl: './global-notification.component.html',
    styleUrls: ['./global-notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GlobalNotificationComponent implements OnInit {
    public globalNotification: boolean = true;
    public changedOn: string;
    public site: string;
    public hasCookieConstentOverlay = false;
    public currentPortal: string;

    private _$portalId: BehaviorSubject<string> = new BehaviorSubject(null);
    public get portalId$(): Observable<string> {
        return this._$portalId.asObservable();
    }
    private _$portalSiteSettings: BehaviorSubject<string> = new BehaviorSubject(null);
    public get portalSiteSettings$(): Observable<string> {
        return this._$portalSiteSettings.asObservable();
    }
    private _$cookieData: BehaviorSubject<[]> = new BehaviorSubject(null);
    public get cookieData$(): Observable<[]> {
        return this._$cookieData.asObservable();
    }

    constructor(
        private _cookieService: CookieService,
        private _translateService: TranslateService,
        private _configurationService: ConfigurationService,
        private _localizeRouterService: LocalizeRouterService
    ) {}

    ngOnInit() {
        if (this._configurationService.hasFeature('ActiveApplications')) {
            this.hasCookieConstentOverlay = true;
        } else {
            this.hasCookieConstentOverlay = false;
        }

        if (this._configurationService.isPartnerPage()) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    this._$portalId.next(portalId);
                    this.currentPortal = this._$portalId.getValue();
                    this._configurationService.getConfigPartnerByPortal().then((values) => {
                        if (values) {
                            const tempFeatures = values.filter((setting) => setting.key.toLowerCase() === 'features');
                            let hasCheckPrerequest;
                            if (tempFeatures && tempFeatures[0] && tempFeatures[0].value && tempFeatures[0].value.length > 0) {
                                hasCheckPrerequest = tempFeatures[0].value.filter((setting) => setting.name === 'ActiveApplications');
                            }
                            if (hasCheckPrerequest && hasCheckPrerequest[0] && hasCheckPrerequest[0].enabled) {
                                this.hasCookieConstentOverlay = true;
                            } else {
                                this.hasCookieConstentOverlay = false;
                            }
                            this._getNotificationData();
                        }
                    });
                }
            });
        }
        this._getNotificationData();
    }

    hideGlobalNotification() {
        this.globalNotification = false;
        this._setCookie();
    }

    private _cookieContent() {
        if (this._configurationService && this._configurationService.getSiteFromUrl() && this._configurationService.getSiteFromUrl().site) {
            this.site = this._configurationService.getSiteFromUrl().site;
        } else {
            this.site = 'global';
        }

        return this.site + '-' + this.changedOn;
    }

    private _setCookie() {
        this._cookieService.set('da_cookie_accpt_v1', this._cookieContent(), 365);
    }

    private _cookieCheck() {
        return this._cookieService.get('da_cookie_accpt_v1') === this._cookieContent();
    }

    private _getNotificationData() {
        if (this._configurationService.isPartnerPage()) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                this._$portalId.next(portalId);
            });
            this._translateService.stream('globalNotification').subscribe((data: any) => {
                if (data && typeof data === 'object') {
                    this.changedOn = data['ChangedOn'];
                    this._$cookieData.next(data);
                    this.globalNotification = !this._cookieCheck();
                }
            });
        } else {
            this._translateService.stream('cookieData').subscribe((res: any) => {
                if (res) {
                    this.changedOn = res['ChangedOn'];
                    this._$cookieData.next(res);
                    this.globalNotification = !this._cookieCheck();
                }
            });
        }
    }
}
